import React, { useState, useEffect, useCallback } from 'react';
import { Box, Typography, Chip, Divider } from '@mui/material';
import dayjs from 'dayjs';
import 'dayjs/locale/it';
import apiClient from '../../config/axios';
// import { useParams } from 'react-router-dom';
dayjs.locale('it');

const UserDetailsPayments = ({ userId, enrollmentId }) => {
    // const { userId } = useParams();
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
  const [payments, setPayments] = useState([]);

  const fetchPayments = useCallback(async () => {
    try {
      const paymentsRes = await apiClient.get(`/api/payments/by-user/${userId}`);
      setPayments(paymentsRes.data || []);
    } catch (err) {
      console.error('Error loading payments:', err);
      setPayments([]);
    }
  }, [userId]);

  useEffect(() => {
    fetchPayments();
  }, [fetchPayments]);

  console.log('userId', userId, 'enrollmentId', enrollmentId);

  // console.log('enrollmentId', enrollmentId);
  // console.log('allPayments', allPayments);
  const getPaymentTypeColor = (type) => {
    // console.log('type', type);
    switch (type) {
      case 'cash':
        return 'info';
      case 'stripe':
        return 'success';
      case 'paypal':
        return 'warning';
      case 'bank_transfer':
        return 'error';
      default:
        return 'default';
    }
  };
  const getPaymentTypeLabel = (type) => {
    switch (type) {
      case 'cash':
        return 'Contanti';
      case 'stripe':
        return 'Stripe';
      case 'paypal':
        return 'PayPal';
      case 'bank_transfer':
        return 'Bonifico Bancario';
      default:
        return type;
    }
  };

  const getEventLabel = (event) => {
    switch (event) {
      case 'nuovo corso':
        return 'Iscrizione';
      case 'rinnovo corso':
        return 'Rata';
      default:
        return event || 'Pagamento';
    }
  };

  const formatCurrency = (amount) => {
    return `€${amount?.toFixed(2) || '0.00'}`;
  };


  console.log('payments', payments);

  // Filter payments for this specific
  //   console.log('allPayments', allPayments);
  const enrollmentPayments = payments?.filter((p) => p.enrollmentId._id === enrollmentId) || [];
//   console.log('enrollmentPayments', enrollmentPayments);
  if (!enrollmentPayments || enrollmentPayments.length === 0) {
    return null;
  }

  
  return (
    <Box sx={{ mt: 2 }}>
      <Divider sx={{ my: 2 }} />
      <Typography variant='subtitle2' sx={{ mb: 1, fontWeight: 600 }}>
        Storico Pagamenti:
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        {enrollmentPayments.map((payment) => (
          <Box
            key={payment._id}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              p: 1,
              backgroundColor: 'background.default',
              borderRadius: 1,
            }}
          >
            <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
              <Typography variant='body2'>
                {getEventLabel(payment.event)} - {formatCurrency(payment.amount)}
              </Typography>
              <Typography variant='body2' color='text.secondary'>
                Registrato da: {payment.registeredBy?.name} {payment.registeredBy?.surname}
              </Typography>
              <Typography variant='caption' color='text.secondary'>
                Registrato il: {payment.createdAt ? dayjs(payment.createdAt).format('DD-MMM-YY') : 'N/A'}
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
              <Chip label={getPaymentTypeLabel(payment.paymentType)} size='small' color={getPaymentTypeColor(payment.paymentType)} />
              {payment.note && (
                <Typography variant='caption' color='text.secondary' sx={{ maxWidth: 150, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {payment.note}
                </Typography>
              )}
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default UserDetailsPayments;
